import { useState, useEffect } from 'react'
import { getPlatformLegalEntity, renderAvisoMyklubb, renderDpa } from '../lib/supabase'

// Obtiene la entidad legal de MYKLUBB (platform_config.legal_entity) una vez y devuelve
// los documentos legales de la plataforma ya renderizados. La lectura de platform_config
// está permitida a anon/authenticated, por lo que sirve también en el login.
export const usePlatformLegal = () => {
  const [legal, setLegal] = useState(null)

  useEffect(() => {
    let cancelled = false
    getPlatformLegalEntity().then(({ data }) => {
      if (!cancelled) setLegal(data || {})
    })
    return () => {
      cancelled = true
    }
  }, [])

  return {
    legal,
    avisoMyklubb: legal ? renderAvisoMyklubb(legal) : null,
    dpa: legal ? renderDpa(legal) : null,
  }
}

export default usePlatformLegal
